module.exports = __webpack_public_path__ + "img/benefits_tests.a8f2a98.svg?v=1747398688961";